/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DynamicPermission
 */
export interface DynamicPermission {
    /**
     * 
     * @type {string}
     * @memberof DynamicPermission
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicPermission
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicPermission
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicPermission
     */
    category: string;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicPermission
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the DynamicPermission interface.
 */
export function instanceOfDynamicPermission(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function DynamicPermissionFromJSON(json: any): DynamicPermission {
    return DynamicPermissionFromJSONTyped(json, false);
}

export function DynamicPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynamicPermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'title': json['title'],
        'description': json['description'],
        'category': json['category'],
        'enabled': json['enabled'],
    };
}

export function DynamicPermissionToJSON(value?: DynamicPermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'title': value.title,
        'description': value.description,
        'category': value.category,
        'enabled': value.enabled,
    };
}

